import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class StructuredStorageReduceHelper extends StructuredStorageBaseHelper {
    constructor({ each, ...rest }) {
        super(rest);
        this.each = each;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        const size = sb.scope.addUnique();
        sb.emitOp(node, 'OVER');
        sb.emitHelper(node, options, sb.helpers.getStructuredStorageSize({ type: this.type }));
        sb.scope.set(sb, node, options, size);
        sb.emitHelper(node, optionsIn, sb.helpers.structuredStorageReduceBase({
            type: this.type,
            each: (innerOptions) => {
                sb.emitOp(node, 'SWAP');
                sb.scope.get(sb, node, innerOptions, size);
                sb.emitHelper(node, options, sb.helpers.if({
                    condition: () => {
                        sb.emitHelper(node, innerOptions, sb.helpers.handleValueStructuredStorage);
                    },
                    whenTrue: () => {
                        sb.emitOp(node, 'ROT');
                        this.each(innerOptions);
                    },
                    whenFalse: () => {
                        sb.emitOp(node, 'DROP');
                        sb.emitOp(node, 'DROP');
                    },
                }));
            },
        }));
    }
}

//# sourceMappingURL=StructuredStorageReduceHelper.js.map
